<template>
  <div class="density">
    <div class="title">运营动态</div>
    <vue-seamless-scroll :data="scrollList" class="right_bottom_scroll" :class-option="classOption">
      <ul class="infinite-list">
        <li v-for="i in scrollList" class="infinite-list-item">
          <span>
            访客用户【{{ i.license }}】使用了交流充电[{{ i.no }}]，消费{{ i.price }}元。
          </span>
          <span style="float: right">{{ i.time }}</span>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      
      classOption: {
        step: 0.5
      },
      scrollList: [
        {
          id: Math.random() * +new Date(),
          no: '56111...',
          price: 34.12,
          license: '鄂FD1551C',
          time: '1天前'
        }, {
          id: Math.random() * +new Date(),
          no: '56135...',
          price: 102.5,
          license: '粤BD8483K',
          time: '1天前'
        }, {
          id: Math.random() * +new Date(),
          no: '56124...',
          price: 98.36,
          license: '鄂AD78789',
          time: '3天前'
        }, {
          id: Math.random() * +new Date(),
          no: '56123...',
          price: 45.28,
          license: '浙AF11895',
          time: '3天前'
        }, {
          id: Math.random() * +new Date(),
          no: '56122...',
          price: 22.16,
          license: '鄂CD2295A',
          time: '3天前'
        }, {
          id: Math.random() * +new Date(),
          no: '56122...',
          price: 77.00,
          license: '豫ED4471C',
          time: '2天前'
        }, {
          id: Math.random() * +new Date(),
          no: '57158...',
          price: 60.31,
          license: '鄂BF6631B',
          time: '2天前'
        },
      ],
    }
  }
}
</script>

<style lang="less" scoped>
.density {
  .h(320);
  .w(592);
  background: #FFFFFF;
  padding: 0 16rem;

  .title {
    height: 45rem;
    line-height: 45rem;
    font-size: 16rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }

  .right_bottom_scroll {
    padding: 0 15px;
    height: calc(100% - 60rem);
    overflow: hidden;

    .infinite-list {
      height: 100%;

      .infinite-list-item {
        height: 42px;
        background-color: rgb(245, 245, 245);
        margin-bottom: 5px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
      }
    }
  }
}
</style>